const styles = {
    cancelRequestMsg: {
        fontSize: "16px",
        fontWeight: 500,
        lineHeight: 1.5,
        letterSpacing: "0.15px",
        paddingBottom: "20px",
    },
    confirmCancelMsg: {
        fontSize: "16px",
        fontWeight: 500,
        lineHeight: 1.5,
        letterSpacing: "0.15px",
    },
    recordCount: {
        padding: "16px",
        fontSize: "16px",
        fontWeight: 400,
        lineHeight: 1.5,
        letterSpacing: "0.15px",
    },
    buttonContainer: {
        display: "flex",
        paddingTop: "12px",
        gap: 2.5,
        paddingY: "20px",
    },
    container: {
        paddingBottom: "20px",
    },
    cardContent: {
        width: "100%",
        height: "auto",
    },
};

export default styles;
